import React, {useState} from "react";
import DevNavSection from "../DevNavSection";

/**
 * Dev menu for updating the client feature flag values within react pages.
 */
export const DevFlagTools = () => {
	const [flags, setFlags] = useState<Record<string, boolean | string>>(
		(global.SERVER_JS_GLOBAL?.BA_FEATURE_FLAGS as Record<
			string,
			boolean | string
		>) || {}
	);
	const flagVariants = global.SERVER_JS_GLOBAL
		?.BA_FEATURE_FLAG_VARIANTS as Record<string, string[]>;
	const setFlag = (flag: string, value: boolean | string) => {
		if (
			global.SERVER_JS_GLOBAL?.BA_FEATURE_FLAGS &&
			flag in global.SERVER_JS_GLOBAL.BA_FEATURE_FLAGS
		) {
			// this is a pretty naive solution to keeping the flags and state in sync
			// we can use the useSyncExternalStore hook if we start doing more bizarre
			// manipulations with the flags, but for now this is more legible and
			// sufficient
			global.SERVER_JS_GLOBAL.BA_FEATURE_FLAGS[flag] = value;
			setFlags(prevFlags => ({...prevFlags, [flag]: value}));
		}
	};
	return (
		<DevNavSection heading="Client Feature Flags">
			{Object.entries(flags).map(([flag, value]) => (
				<div key={flag}>
					<label>
						{typeof value === "boolean" && (
							<input
								type="checkbox"
								checked={value}
								onChange={() => setFlag(flag, !value)}
							/>
						)}
						{typeof value === "string" && (
							<select
								value={value}
								onChange={e => setFlag(flag, e.target.value)}
							>
								{flagVariants[flag].map(variant => (
									<option value={variant}>{variant}</option>
								))}
							</select>
						)}
						{flag}
					</label>
				</div>
			))}
		</DevNavSection>
	);
};
